// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"d79f13904bdebf17","6831":"97deb12344aac04b","8503":"4a540bfe7e47cb75","9683":"bb84238c4175504d"}[chunkId] + ".js";
};